import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React, { useState } from "react";
import { CardGrid, Image } from "../../../../Styles/style";
import SectionsHeading from "../../../MainComponent/SectionsHeading";
import Paragraph from "../../../MainComponent/Paragraph";
import image1 from "../../../../../assets/Images/largeeth.png";
import image2 from "../../../../../assets/Images/largeshia.png";
import CustomButton from "../../../MainComponent/CustomBtn";

const GridWrapper = styled(Grid)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: auto;
  column-gap: 20px;
  row-gap: 20px;
`;

const RowDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
`;
const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0 10px;
  column-gap: 5px;
`;
const InputDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: #333333;
  border-radius: 10px;
  padding: 5px 10px;
`;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: #0d0d0d;
  border-radius: 10px;
  padding: 10px;
`;
const Input = styled.input`
  background-color: transparent;
  color: #fff;
  font-family: PoppinsR;
  font-size: 16px;
  width: 100%;
  padding: 0 10px;
  box-shadow: none;
  border: none;
  :focus {
    outline: none;
  }
`;
const CoulmnDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const BorrowDetailPage = () => {
 
  const [inputValue, setInputValue] = useState(0);
  const [innerSecState, setInnerSecState] = useState(0);

  const handleChange = (value) => {
    setInputValue(value);
  };

  return (
    <GridWrapper container>
      <CardGrid itemxs={12} sm={5.7}>
        <SectionsHeading
          fm="PoppinsSB"
          fs="16px"
          fs599="16px"
          ta="left"
          color="#FC9D00"
        >
          Borrow ETH
        </SectionsHeading>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            You Borrowed:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            00
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Total Collateral:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            1000 SHIA
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Borrow Fee:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            1.5%
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Loan To Value:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left" color="#9CFF1A">
            80%
          </Paragraph>
        </RowDiv>
      </CardGrid>
      {/* ///////////////////////////////////////// */}
      <CardGrid itemxs={12} sm={5.8}>
        <SectionsHeading
          fm="PoppinsSB"
          fs="16px"
          fs599="16px"
          ta="left"
          color="#FC9D00"
        >
          ETH Reserves Overview
        </SectionsHeading>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Asset Price:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            $1685
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            ETH Available Liquidity:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            100
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Maximum LTV:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            80%
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Liquidation Threshold:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            85%
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Liquidation Penalty:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            5%
          </Paragraph>
        </RowDiv>
      </CardGrid>
      {/* ///////////////////////////////////////// */}
      <CardGrid p="30px 10px" ai="center" jc="center" container item xs={12}>
        <Grid
          item
          xs={12}
          sm={5}
          sx={{ display: "flex", rowGap: "10px", flexDirection: "column" ,width:"100%"}}
        >
          {innerSecState === 0 ? (
            <>
              <SectionsHeading
                fm="PoppinsSB"
                fs="16px"
                fs599="16px"
                ta="center"
                color="#FC9D00"
              >
                How Much Would You Like To Borrow?
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="center">
                Please enter an amount you would like to borrow. The maximum
                amount you can borrow is shown below.
              </Paragraph>
              <RowDiv>
                <Paragraph
                  p="0"
                  fs="12px"
                  ta="center"
                  fm="PoppinsB"
                  color="#707070"
                >
                  Available To Borrow:
                </Paragraph>
                <Paragraph p="0" fs="12px" ta="center" color="#707070">
                  0.05 ETH
                </Paragraph>
              </RowDiv>
              <InputDiv>
                <FlexDiv>
                  <Image src={image1} />
                  <Input
                    value={inputValue}
                    onChange={(event) => {
                      handleChange(event.target.value);
                    }}
                  />
                </FlexDiv>
                <CustomButton
                  w="30px"
                  bgc="transparent"
                  c="#FE9C02"
                  hbgc="transparent"
                  hc="#FE9C02"
                >
                  MAX
                </CustomButton>
              </InputDiv>
            </>
          ) : innerSecState === 1 ? (
            <>
              <SectionsHeading
                fm="PoppinsSB"
                fs="16px"
                fs599="16px"
                ta="center"
                color="#FC9D00"
              >
                Borrow Overview
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="center">
                These are your transaction details. Make sure to check if this
                is correct before submitting.
              </Paragraph>
              <Div>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Borrow Amount
                  </Paragraph>
                  <FlexDiv>
                    <Image mw="20px" src={image1} />
                    <Paragraph fs="14px" ta="center">
                      {inputValue}
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Collateral Amount:
                  </Paragraph>
                  <FlexDiv>
                    <Image mw="20px" src={image2} />
                    <Paragraph fs="14px" ta="center">
                      1000
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
              </Div>
            </>
          ) : (
            <>
              <SectionsHeading
                fm="PoppinsSB"
                fs="16px"
                fs599="16px"
                ta="center"
                color="#FC9D00"
              >
                Borrow Overview
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="center">
              Your action has been successfully executed
              </Paragraph>
            <Div>
              <CoulmnDiv>
                <Image mw="60px" src={image1} />
                <Paragraph fs="12px" fm="PoppinsB" ta="center" color="#9CFF1A">
                  0.05 ETH Token Successfully Borrowed
                </Paragraph>
              </CoulmnDiv>
            </Div></>
          )}

          <RowDiv>
            <CustomButton
              m="0"
              onClick={() => {
                setInnerSecState(innerSecState + 1);
              }}
              bgc="#FE9C02"
              c="#000"
              hbgc="#000"
              hc="#FE9C02"
            >
              {innerSecState === 0
                ? "Continue"
                : innerSecState === 1
                ? "Approve"
                : "Dashboard"}
            </CustomButton>
            <Paragraph
              p="0"
              fs="12px"
              ta="center"
              fm="PoppinsB"
              color="#707070"
            >
              {innerSecState === 0
                ? "0/2"
                : innerSecState === 1
                ? "1/2"
                : "2/2"}
            </Paragraph>
          </RowDiv>
        </Grid>
      </CardGrid>
      {/* ///////////////////////////////////////// */}
    </GridWrapper>
  );
};

export default BorrowDetailPage;
